/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SendInviteRequestBody = {
  /**
   * Email address to invite.
   */
  email: string;
  /**
   * Optional role ID for the invitee.
   */
  roleId?: string | undefined;
};

/** @internal */
export type SendInviteRequestBody$Outbound = {
  email: string;
  role_id?: string | undefined;
};

/** @internal */
export const SendInviteRequestBody$outboundSchema: z.ZodMiniType<
  SendInviteRequestBody$Outbound,
  SendInviteRequestBody
> = z.pipe(
  z.object({
    email: z.string(),
    roleId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      roleId: "role_id",
    });
  }),
);

export function sendInviteRequestBodyToJSON(
  sendInviteRequestBody: SendInviteRequestBody,
): string {
  return JSON.stringify(
    SendInviteRequestBody$outboundSchema.parse(sendInviteRequestBody),
  );
}
